var map = {
	"./ArrowIcon.svg": 3594,
	"./CVAT.png": 2240,
	"./Ellipse 65.svg": 2775,
	"./FreeUserStar.svg": 949,
	"./Moondream_logo.svg": 8940,
	"./Rectangle-new.svg": 1956,
	"./S3-upload.svg": 3158,
	"./VL-Beta-Logo.svg": 789,
	"./Vector239.svg": 695,
	"./VectorLogo.svg": 8954,
	"./account-tree-menu-open.svg": 5529,
	"./allen_ai_logo.svg": 2547,
	"./anonymous_user.svg": 2401,
	"./arrow.svg": 2013,
	"./arrowDown.svg": 8057,
	"./arrowUp.svg": 9526,
	"./arrow_back.svg": 7993,
	"./arrow_right_rectangle.svg": 628,
	"./auto-renew.svg": 8463,
	"./avatar.svg": 7953,
	"./bigImg.svg": 6585,
	"./bin.svg": 5037,
	"./blank.png": 6752,
	"./blue-cross-icon.svg": 4981,
	"./camera.svg": 3755,
	"./card-image.svg": 7524,
	"./chat.svg": 1660,
	"./chatOpenGo.svg": 9350,
	"./check-circle.svg": 9451,
	"./chevron copy.svg": 3074,
	"./chevron.svg": 1943,
	"./clockIcon.svg": 8359,
	"./cloud-white.svg": 5049,
	"./cloud.svg": 6965,
	"./cluster-inventory-logo.svg": 4333,
	"./cluster-sizing-icon-big.svg": 9198,
	"./cluster-sizing-icon-small.svg": 3225,
	"./clusterLogo.svg": 8265,
	"./colored-file-storage.svg": 2763,
	"./colored-setting.svg": 2867,
	"./colored-to-do-list.svg": 7381,
	"./cross.svg": 190,
	"./crossImg.svg": 1139,
	"./danger.svg": 9307,
	"./dataInventoryResume.svg": 4459,
	"./dataset.svg": 1886,
	"./dateCreated.svg": 6734,
	"./deepseek_logo.svg": 7494,
	"./deleteDataset.svg": 3417,
	"./download-icon-black.svg": 4853,
	"./download-icon-white.svg": 6328,
	"./download-loader.gif": 5533,
	"./edit.svg": 9338,
	"./ellipseBlack.svg": 6073,
	"./ellipseWhite.svg": 3343,
	"./eye.svg": 5297,
	"./failed.svg": 353,
	"./fancy-right-arrow.svg": 268,
	"./filter-menu-open.svg": 917,
	"./filter.svg": 9500,
	"./filter_2.svg": 4955,
	"./fix.svg": 2703,
	"./folder.svg": 6,
	"./freePlan.svg": 8537,
	"./github-logo.svg": 577,
	"./google-logo.svg": 3905,
	"./googleIcon.svg": 6052,
	"./gpt_symbol.svg": 1688,
	"./grayBorderCircle.svg": 6705,
	"./greenTick.svg": 388,
	"./grey-info-icon.svg": 8590,
	"./grid.svg": 6374,
	"./group-users.svg": 6184,
	"./group.svg": 5055,
	"./hurrah-image.svg": 484,
	"./imageTab.svg": 5674,
	"./indexing.svg": 6406,
	"./layers-magic.svg": 1562,
	"./line_view.svg": 4416,
	"./lion-3626.svg": 5910,
	"./lion-body.svg": 9201,
	"./lion-face.svg": 494,
	"./lion-front.svg": 1238,
	"./lion-hover.svg": 1017,
	"./lion-skin.svg": 5814,
	"./lion-sleep.svg": 5930,
	"./local_upload.svg": 6469,
	"./lock.svg": 1447,
	"./log_out.svg": 2797,
	"./login-vllogo.svg": 1121,
	"./logout.svg": 3292,
	"./magnifying-glass.svg": 7882,
	"./maxAmountDataset.svg": 7632,
	"./media.svg": 5150,
	"./menu-open.svg": 3696,
	"./message.svg": 51,
	"./minus.svg": 8682,
	"./modalBlackCross.svg": 6817,
	"./nest-wifi-route-white.svg": 9498,
	"./nest-wifi-router.svg": 928,
	"./newVLicon.svg": 5457,
	"./no-results-icon.svg": 128,
	"./no-search.svg": 2888,
	"./nvidia_symbol.svg": 5234,
	"./open_gv_lab.png": 6586,
	"./ovis2.svg": 6173,
	"./pencil-icon.svg": 2409,
	"./placeholder-image.svg": 1297,
	"./plane.svg": 3156,
	"./plus-black.svg": 5376,
	"./plus.svg": 4034,
	"./preview-info-icon.svg": 8367,
	"./privateIcon.svg": 4204,
	"./pro-plan.svg": 5021,
	"./publicIcon.svg": 6070,
	"./qwen_logo.svg": 2015,
	"./radioButtonIcon.svg": 5904,
	"./ready.svg": 7379,
	"./rocket.svg": 1630,
	"./scan.svg": 5413,
	"./search.svg": 2054,
	"./size.svg": 7705,
	"./something-went-wrong-icon.svg": 6425,
	"./square-plane.svg": 1570,
	"./star.svg": 6822,
	"./star_without_bg.svg": 8559,
	"./subtract.svg": 3890,
	"./tag-icon-black.svg": 4138,
	"./tag-icon.svg": 4368,
	"./timeline.svg": 4371,
	"./timelineIcon.svg": 3364,
	"./trash.svg": 8,
	"./tuneIcon.svg": 7607,
	"./union.svg": 7611,
	"./upload-dataset.svg": 9682,
	"./upload-icon.svg": 3833,
	"./upload-purple.svg": 2316,
	"./upload.svg": 4341,
	"./uploading.svg": 8379,
	"./user.svg": 2751,
	"./users2.svg": 3712,
	"./vector-menu-open.svg": 7454,
	"./vector-white.svg": 483,
	"./vector.svg": 8259,
	"./visual-layer-text-logo.svg": 9298,
	"./vl-cloud-title.svg": 8009,
	"./vllogo-with-label.svg": 4455,
	"./vllogo.svg": 5317,
	"./zoom-control.svg": 267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;